import client from './client'
import install from './install'

// 子模块
import video from './video'
import user from './user'
import topic from './topic'
import fmList from './fmList'
import theme from './theme'
import live from './live'
import tag from './tag'
import album from './album'
import service from './service'
import coupon from './coupon'
import author from './author'
import ecology from './ecology'
import api from './api'
import apiAsync from './apiAsync'
import groupChat from './groupChat'
import trader from './trader'

/**
 * 管理端 登录验证
 * http://gitlab.yintech.net/spero/vision/backend/spero-album-service
 */
export default class UltronApi {
  constructor (options, vm) {
    if (UltronApi.instance) {
      throw new Error('UltronApi is singleton')
    }
    UltronApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.video = video
    this.user = user
    this.topic = topic
    this.fmList = fmList
    this.theme = theme
    this.live = live
    this.tag = tag
    this.album = album
    this.service = service
    this.coupon = coupon
    this.author = author
    this.ecology = ecology
    this.api = api
    this.apiAsync = apiAsync
    this.groupChat = groupChat
    this.trader = trader
  }
  static getInstance () {
    return UltronApi.instance
  }
}

UltronApi.instance = null
UltronApi.install = install



// WEBPACK FOOTER //
// ./src/apis/ultron-api/index.js